import React, { useEffect, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import Container from "@material-ui/core/Container";

function VipUserManagement() {
  const [nbVipUser, setNbVipUser] = useState("");

  // Permet de récupéprer le nombre de client VIP du coach connecté
  const getStatsVIPClients = async () => {
    let requestURL = window.$apiURL.toString() + "coachs/nb_users";
    let requestOptions = {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("cbs_perform_token"),
      },
    };
    const responsePromise = await fetch(requestURL, requestOptions);
    const data = await responsePromise.json();
    if (responsePromise.ok) {
      setNbVipUser(data.nb_users_vip);
    } else if (responsePromise.status === 404) {
      window.location.replace("/404");
    }
  };

  useEffect(() => {
    getStatsVIPClients({});
  }, []);

  // Affichage de la page
  return (
    <div>
      <Container component={"main"} maxWidth={"xs"} className="divRequest">
        <Typography
          component="h1"
          variant="h3"
          style={{ paddingBottom: "15%" }}
        >
          Utilisateurs VIP
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid item xs={12} style={{ textAlign: "left" }}>
              <b>Utilisateurs ayant l'abonnement VIP : </b> {nbVipUser}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
export default VipUserManagement;
